module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("ACROSS THE MILLENIA")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/com.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("That all wisdom can be reduced to 64 simple symbols might appear impossible, but such has been our search for divine assistance and inspiration that throughout Chinese recorded history people have striven to do so.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("During the Lungshan period, some 4000 years ago, it is thought that predicting the future was achieved by burning a cow’s shoulder-blade while a question was being asked. The heat cracked the bone and the shaman would deduce the answer from the position and shape of the cracks. It then became the custom for the question to be inscribed onto the shoulder-blade before it was scored by a hot bronze instrument.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As divination became more ritualized, a tortoise shell replaced the shoulder-blade, as the tortoise was a symbol of stability and longevity and, as such, was much venerated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("At this point, it is thought that the legendary First Emperor of China, Fu Hsi, discovered the Eight Trigrams of "), _c('em', [_vm._v("I Ching")]), _vm._v(" as a permanent feature on the back of a tortoise shell. One of the oldest commentaries on "), _c('em', [_vm._v("I Ching")]), _vm._v(" tells how:")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0008-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('em', [_vm._v("“In ancient times, when Pao Hsi (Fu Hsi) ruled all things under heaven, he looked up and contemplated the bright patterns of the sky, then looked down and considered the shapes of the earth around him. He noted the decorative markings of the birds and beasts and the qualities of their territories. He observed at close hand his own body. From all this he devised the Eight Trigrams, in order to unveil the heavenly processes and to understand the character of everything.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The next stage in the development of "), _c('em', [_vm._v("I Ching")]), _vm._v(" took place around 1150"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(", when a feudal lord called Wen was imprisoned by the incompetent Emperor Chou Hsin. While under the threat of death, he studied the Eight Trigrams and eventually compiled the 64 Hexagrams, which combined the qualities of the Trigrams. After his release, Wen and his rebels in the province of Chou defeated and killed the Emperor, thus ending the Shang Dynasty and starting the Chou Dynasty After Wen’s son, Tan, became Duke of Chou, he expanded his father’s work on the Hexagrams and added his own interpretation to every single line, thus creating 384 extra layers of "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("meaning to "), _c('em', [_vm._v("I Ching,")]), _vm._v(" which were called Chou I (the Change of Chou).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In the early part of the fifth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(", Confucius studied the Chou I and it is thought he added to the commentaries. Eventually, these thoughts, and those of his pupils, became an added volume to "), _c('em', [_vm._v("I Ching,")]), _vm._v(" the name having only just been adopted for the system.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("I Ching")]), _vm._v(" survived the burning of ancient literature ordered by Emperor Ch’in Shih Huang Ti, builder of the Great Wall of China. He thought it essential for his successful rule of the new, united China. He also thought it a useful treatise to advise on the conduct of war. Over 450 scholars were executed for concealing other ancient texts and many more became slave labour on the building of the Great Wall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("During the Ch’in and Han Dynasties (3rd century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" to 3rd century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v("), the diagrams were further classified, many being reinterpreted by magicians. But in the last half of the third century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v(", the young scholar Wang Pi reaffirmed the essentially mystical side of the original work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("Just as Emperor Ch’in Shih Huang Ti found "), _c('em', [_vm._v("I Ching")]), _vm._v(" a useful tool of governance, so many other Chinese leaders have used it for the conduct of war. In this century, the Chinese nationalist leader Chiang Kai-Shek consulted it, as did his Communist opponent, Chairman Mao. Although many ancient beliefs were supressed under his regime, "), _c('em', [_vm._v("I Ching")]), _vm._v(" survived.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The first translation of "), _c('em', [_vm._v("I Ching")]), _vm._v(" was by Jesuit missionaries. A French edition, "), _c('em', [_vm._v("Le Yih-King,")]), _vm._v(" was published in 1889, and an English edition was published by James Legge of Oxford in 1899. The German edition, significantly, had a foreword by the eminent psychologist C.G. Jung, who was the first westerner to realize and promote the universal significance of "), _c('em', [_vm._v("I Ching.")]), _vm._v(" When he used it he recorded remarkable results, adding to it much of his theory of the subconscious.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0011-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0012-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The great depth of understanding found in "), _c('em', [_vm._v("I Ching")]), _vm._v(" was originally created for, and by, Emperors, their courtiers and their generals. Added to by Confucius, whose Analects were the bible of proper and seemly behaviour for those who governed, they became a general guide to life for many millions. They are written as inscrutable parables and folk tales, which require detailed translation. In this small volume only key words are offered, which do scant justice to the mighty originals, which must be consulted for the full truth. Cultivated through the millenia, this accumulated and refined knowledge is now here to help us understand and cope with the many pitfalls we might encounter on the way, path or tao, which runs through our lives.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0013-01.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3574bc0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter01.vue
// module id = 75
// module chunks = 0